import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  NgModule,
  OnDestroy,
  ViewChild,
  HostListener,
} from '@angular/core';
import {BehaviorSubject, combineLatest, fromEvent, interval, Observable, Subject} from "rxjs";
import "rxjs-compat/add/observable/fromEvent";
import {DrawingEditorToolsComponent} from "../../components/drawing-editor-tools/drawing-editor-tools.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {debounceTime, map, takeUntil, throttle} from "rxjs/operators";
import {appInjector} from "../../classes/appInjector";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {EventConfigProvider} from "../../classes/EventConfigProvider";
import {Item} from "../../models/Item";
import {isViewMode, isViewModeByShareLink} from '../../../configs/view_only';
import {animateShow} from "../../animations/showHideAnimation";
import { DrawingEditorToolsService } from './drawing-editor-tools.service';
import {MultiselectTopGroupComponent} from '../multiselect-top-group/multiselect-top-group.component';
declare const Yiit;

@Component({
  selector: 'app-drawing-editor-tools',
  animations: [
    trigger('openClose', [
      state('opened', style({
        height: '*',
        visibility: 'visible',
        overflow: 'hidden'
      })),
      state('closed', style({
        height: '0px',
        visibility: 'hidden',
        overflow: 'hidden'
      })),
      transition('opened <=> closed', [
        animate('0.5s ease')
      ]),
    ]),
      animateShow
  ],
  templateUrl: './drawing-editor-tools.component.html',
  styleUrls: ['./drawing-editor-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrawingEditorToolsComponent21 extends DrawingEditorToolsComponent implements AfterViewChecked, OnDestroy {
  private selectedCategory$ = new BehaviorSubject(null);
  private destroyer$: Subject<void> = new Subject();
  public selectedTab$ = new BehaviorSubject(null);
  public isMultiSelectActive:boolean = false;
  public _hideLeftSidebar:boolean;
  get hideLeftSidebar():boolean {
    return this._hideLeftSidebar;
  }
  set hideLeftSidebar(b) {
    this._hideLeftSidebar = b;
    this._hideLeftSidebar$.next(b);
    this.domEvents.sidebarState$ = !b;
  }
  public _hideLeftSidebar$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  get sidebarState(): Observable<boolean> {
    return this._hideLeftSidebar$.asObservable();
  }
  get selectedTab() {
    return this.selectedTab$.asObservable();
  }
  get selectedCategory(){
    return this.selectedCategory$.asObservable();
  }
  private tabNameList = {default: Yiit.t('Placed Objects'), concrete: Yiit.t('Placed Objects')};
  public selectedCategoryText = Yiit.t('Placed Objects');
  public selectedCategoryItem = null;
  public searchText = null;
  public searchFocusStatus = false;
  public parentCategoryName = null;
  public isShowChevrons = false;
  public searchSuggestions$: Observable<any>;
  private _isGridMode = true;
  private isInited = false;
  private uiAdapter;
  private concreteService;
  private itemManager;
  private drawingEditorToolsService: DrawingEditorToolsService;
  private openedTools = {};
  private leftSidebarScrollbar = null;
  private resize$ = fromEvent(window, 'resize').pipe(
    throttle((config)=>interval(300), {trailing: true})
  );
  public Yiit = Yiit;
  public totalObjects = 0;
  public drawnObjects = 0;
  public isViewOnly = isViewMode || isViewModeByShareLink;

  private leftPanelOffset = 0;
  private leftPanel = null;
  private maxPanelOffset = 0;

  @ViewChild('multiselectTopGroup', {static: true}) multiselectTopGroup: MultiselectTopGroupComponent;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
      this.view.clearDrawingTool();
      this.ms.isMultiSelectActive$ = false;
      this.cd.detectChanges();
  }

  ngOnInit() {
    super.ngOnInit();
    this.concreteService = appInjector.get(ConcreteLayerService);
    this.hideLeftSidebar = true;
    this.uiAdapter = appInjector.get(UiAdapterService);
    this.itemManager = appInjector.get(ItemManagerService);
    this.drawingEditorToolsService = appInjector.get(DrawingEditorToolsService);
    this.ms.isMultiSelectActive$.subscribe((flag) => {
      this.isMultiSelectActive = flag;
      this.cd.detectChanges();
    });
    this.selectedCategory$.subscribe((config)=>{
      if (config){
        this.selectedCategoryText = config.category.name;
        this.selectedCategoryItem = config;
        // setTimeout(()=>{
        //   let content:HTMLElement = document.querySelector('.es-navbar-container .fakeScroll__content');
        //   content.style.overflow = 'hidden';
        //   this.cd.detectChanges();
        // }, 400);
      }
      else{
        this.selectedCategoryItem = null;
        // let content:HTMLElement = document.querySelector('.es-navbar-container .fakeScroll__content');
        // if (content){
        //   content.style.overflow = 'auto';
        // }
        this.selectedCategoryText = Yiit.t('Placed Objects');
        this.parentCategoryName = null;
      }
      this.cd.detectChanges();
    });

    this.initItemManager();

    EventConfigProvider().subscribe((eventConfig)=>{
      let items = eventConfig.items;
      if (Object.keys(items).length > 0){
        this.setSelectedTab('concrete');
      }
    });

    this.uiAdapter.selectedItem$.subscribe((item)=>{
      if (item && !this.isInited){
        item.getChildren().subscribe((config)=>{
          if (config.length > 0){
            // this.setSelectedTab('concrete');
            this.isInited = true;
            this.cd.detectChanges();
          }
        })
      }
    })

    this.drawingEditorToolsService.onCollapseGroups$
      .pipe(takeUntil(this.destroyer$))
      .subscribe(() => {
        this.openCategoryList = [];
      });
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.unsubscribe();
  }

  initItemManager() {
    if (!this.itemManager.itemList) {
      setTimeout(() => { this.initItemManager(); }, 100);
      return;
    }
    this.itemManager.itemList.pipe(debounceTime(500)).subscribe((list) => {
      this.totalObjects = list.length;
      for (let i in list) {
        if (list[i].isDrawn) {
          this.drawnObjects++;
        }
      }
      this.cd.markForCheck();
      this.cd.detectChanges();
    });
    // this.itemManager.itemAdded.subscribe((item) => {
    //   item.getSubject(Item.AFTER_DRAWN_SUBJECT).subscribe((success) => {
    //     if (success) {
    //       this.drawnObjects++;
    //       this.cd.markForCheck();
    //       // this.cd.detectChanges();
    //     }
    //   })
    // });
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    Scrollbar.initAll();

    this.toolsListLoaded.subscribe((status)=>{
      if (status){
        this.leftSidebarScrollbar = Scrollbar.get(document.querySelector('.es-left-part'));
        this.isShowChevrons = this.leftSidebarScrollbar && this.leftSidebarScrollbar.limit.y > 0;
        if (this.isShowChevrons){
          this.leftSidebarScrollbar.limit.y += 20;
        }
      }
    });

    this.cd.detectChanges();
  }

  // toggleMultiSelect(){
  //   this.isMultiSelectActive = !this.isMultiSelectActive;
  //   this.cd.detectChanges();
  // }

  takeTool(tool): boolean {
    this.ms.isMultiSelectActive$ = false;
    this.cd.detectChanges();
    return super.takeTool(tool);
  }
  clearSearchText() {
    this.searchText = '';
    this.searchFocusStatus = false;
    this.cd.detectChanges();
  }
  toggleMultiSelect() {
    this.isMultiSelectActive = !this.isMultiSelectActive;
    this.cd.detectChanges();
  }

  setSearchFocus(flag) {
    this.searchFocusStatus = flag;
    this.cd.detectChanges();
  }

  isOpenSearchMenu() {
    return (this.searchText && this.searchText.length >= 2) && this.searchFocusStatus && !this.hideLeftSidebar;
  }

  moveToTop(){
    if (this.leftSidebarScrollbar.offset.y <= 0){
      this.leftSidebarScrollbar.scrollTo(0, 0, 300);
      return;
    }
    let nextVal = this.leftSidebarScrollbar.scrollTop - 64;

    if (nextVal <= 0){
      this.leftSidebarScrollbar.scrollTo(0, 0, 300);
      return;
    }
    this.leftSidebarScrollbar.scrollTo(0, nextVal, 300);
    this.cd.detectChanges();
  }

  moveToBottom(){
    if (this.leftSidebarScrollbar.offset.y >= this.leftSidebarScrollbar.limit.y + 10){
      this.leftSidebarScrollbar.scrollTo(0, this.leftSidebarScrollbar.limit.y + 10, 300);
      return;
    }
    let nextVal = this.leftSidebarScrollbar.offset.y + 64;
    if (nextVal >= this.leftSidebarScrollbar.limit.y + 10){
      this.leftSidebarScrollbar.scrollTo(0, this.leftSidebarScrollbar.limit.y + 10, 300);
      return;
    }

    this.leftSidebarScrollbar.scrollTo(0, nextVal, 300);
    this.cd.detectChanges();
  }

  setSelectedTab(val: any, key?: string){
    // Check for unsaved overlays
    if (val !== 'layouts' && this.overlayService.hasUnsavedLayoutChanges()) {
      if (!confirm('You have not saved the changes made to the overlay. Proceed anyway?')) {
        return false;
      }

      this.overlayService.activeOverlayReset$.next();
    }

    this.selectedTab$.next(val);

    this.selectedCategory$.next((val == 'concrete') ? null : this.selectedCategory$.getValue());
    // this.selectedCategoryText = (val) ? this.tabNameList[val]: this.tabNameList.default;
    if(val.category){
      this.selectedCategoryText = val.category.name;
      this.selectedTab$.next(val.category.name);
    }
    else{
      if(val === "concrete"){
        this.selectedCategoryText  = "Placed Objects";
        return;
      }
      else{
        this.selectedCategoryText = val;
      }
    }
    let scrollbars = Scrollbar.getAll();
    scrollbars.forEach((scrollbar)=>{
      scrollbar.scrollTop = 0;
    });
    this.cd.detectChanges();

    if (this.isCategory(val)) {
      this.setToolOpenStatus(key);
    } else {
      if (val == 'concrete'){
        return true;
      }
      this.takeTool(val);
    }

    return true;
  }

  getSelectedTabName(toolItem){
    if (toolItem instanceof Object && toolItem.hasOwnProperty('category')){
      return toolItem.category.name;
    }
    return toolItem;
  }

  setToolOpenStatus(levelItem){
    this.openedTools[levelItem] = !this.openedTools[levelItem];
    this.cd.detectChanges();
  }

  selectSubCategory(item, value?){
    if (!item){
      this.setSelectedTab(this.selectedTab$.value);
      return this.selectedCategory$.next(null);
    }
    this.selectedCategory$.next(item);
    if (value){
      this.parentCategoryName = value;
    }
    this.cd.detectChanges();
  }

  isOpened(level1Item){
    return this.openedTools[level1Item];
  }

  isGridMode(){
    return this._isGridMode;
  }

  changeGridMode(){
    this._isGridMode = !this._isGridMode;
    this.cd.detectChanges();
  }
  toggleStateOfSidebar(){
    if(this.selectedTab$.value === null){
      this.setSelectedTab('concrete');
    }
    this.hideLeftSidebar = !this.hideLeftSidebar;
    if (this.hideLeftSidebar) {
      this.multiselectTopGroup.isGroupActionsVisible = false;
    }
    this.cd.detectChanges();
  }
  openSidebar(){
    if(this.hideLeftSidebar === false){
      return;
    }
    this.hideLeftSidebar = false;
    this.cd.detectChanges();
  }

  ngAfterViewChecked(): void {
    Scrollbar.getAll().forEach(sb => { sb.update(); });
  }

  canSeeTools(): boolean {
    return !isViewMode;
  }
}
